/* ============================================================
   Custom Collection Page JS
   配套 Dawn 主题使用
   包含：横向滑块、公告栏关闭、标签筛选高亮
   ============================================================ */

(function () {
  'use strict';

  /* ------------------------------------------------------------
     1. 通用横向滑块（Match With / Shop More Collections）
     作用：给每个 [data-slider] 容器的左右箭头绑定滚动
     ------------------------------------------------------------ */
  function initSliders() {
    var sliders = document.querySelectorAll('[data-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (container) {
      var track = container.querySelector('.cs-track');
      var prev = container.querySelector('[data-slider-prev]');
      var next = container.querySelector('[data-slider-next]');
      if (!track || !prev || !next) return;

      // 每次滚动的距离（按容器宽度的 80% 计算，更自然）
      function getScrollAmount() {
        return Math.max(240, track.clientWidth * 0.8);
      }

      // 左箭头
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      // 右箭头
      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      // 根据滚动位置，动态控制箭头禁用状态
      function updateArrowState() {
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      track.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      // 初始化
      setTimeout(updateArrowState, 100);
    });
  }

  /* ------------------------------------------------------------
     2. 公告栏关闭（session 内永久隐藏）
     作用：点击 × 后关闭公告，并在同一浏览器会话内不再显示
     ------------------------------------------------------------ */
  function initAnnouncementBar() {
    var bars = document.querySelectorAll('[data-announcement-bar]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var closeBtn = bar.querySelector('[data-announcement-close]');
      if (!closeBtn) return;

      // 如果之前已经关闭过，直接隐藏
      if (sessionStorage.getItem('announcementClosed') === 'true') {
        bar.classList.add('hidden');
      }

      closeBtn.addEventListener('click', function () {
        bar.classList.add('hidden');
        sessionStorage.setItem('announcementClosed', 'true');
      });
    });
  }

  /* ------------------------------------------------------------
     3. 快捷标签筛选高亮
     作用：点击标签时，确保视觉上高亮当前选中项
     （实际筛选逻辑走 Dawn 原生的 tag URL，这里只做视觉反馈）
     ------------------------------------------------------------ */
  function initTagFilter() {
    var tagBar = document.querySelector('.custom-tag-filter');
    if (!tagBar) return;

    var tags = tagBar.querySelectorAll('.ctf-tag');
    if (!tags.length) return;

    tags.forEach(function (tag) {
      tag.addEventListener('click', function () {
        tags.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ------------------------------------------------------------
     4. 分类简介 / FAQ 折叠增强（可选）
     作用：让 FAQ 手风琴同时只展开一个（Dawn 默认允许多个同时开）
     ------------------------------------------------------------ */
  function initFaqAccordion() {
    var faqItems = document.querySelectorAll('.cfaq-item');
    if (!faqItems.length) return;

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          faqItems.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  /* ------------------------------------------------------------
     5. 初始化入口
     ------------------------------------------------------------ */
  function init() {
    initSliders();
    initAnnouncementBar();
    initTagFilter();
    initFaqAccordion();
  }

  // DOM 加载完执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 兼容 Dawn 主题编辑器动态加载场景
  document.addEventListener('shopify:section:load', init);
})();